import {Component, OnInit, Input} from '@angular/core';
import {Produto} from 'src/app/home/home/conteudo/produtos/produto';
import {ProdutosService} from 'src/app/home/home/conteudo/produtos/produtos.service';
import {Page} from 'src/app/page';
import {Observable} from 'rxjs';

@Component({
    selector: 'store-pesquisa-resultados',
    templateUrl: './resultados-pesquisa.component.html',
    styleUrls: ['./resultados-pesquisa.component.scss']
})
export class ResultadosPesquisaComponent implements OnInit {

    @Input()
    public produtos: Observable<Page<Produto>>;

    @Input()
    public tagsPesquisa: Array<string>;

    @Input()
    public filtros: Map<string, any>;

    constructor(private produtosService: ProdutosService) {
    }

    ngOnInit() {
        this.tagsPesquisa = this.tagsPesquisa || [];
    }

}
